import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';
import { Club } from '~/apis/ssf';

interface Props {
  club: Pick<Club, 'district' | 'rfnr' | 'is_active' | 'website' | 'email'>;
}

export function GeneralInformation({ club }: Props) {
  return (
    <Fragment>
      <PageLayout.SubHeading>Övergripande information</PageLayout.SubHeading>

      <Table bg="odd">
        <Table.Body>
          <Table.Row>
            <Table.Col as="th">Distrikt</Table.Col>
            <Table.Col>{club.district.name}</Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col as="th">Föreningsnummer</Table.Col>
            <Table.Col>{club.rfnr ?? '-'}</Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col as="th">Hemsida</Table.Col>
            <Table.Col>
              {club.website ? (
                <Link to={club.website} target="_blank">
                  {club.website}
                </Link>
              ) : (
                '-'
              )}
            </Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col as="th">Email</Table.Col>
            <Table.Col>{club.email ? <Link to={`mailto:${club.email}`}>{club.email}</Link> : '-'}</Table.Col>
          </Table.Row>

          <Table.Row>
            <Table.Col as="th">Föreningsstatus</Table.Col>
            <Table.Col>{club.is_active ? 'Aktiv' : 'Inaktiv'}</Table.Col>
          </Table.Row>
        </Table.Body>
      </Table>
    </Fragment>
  );
}
